import React from "react";
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";

type Props = {
  style: string,
  icon: string,
  title: string,
  subtitle: string
}

export const AppCardWidget = ({ style, icon, title, subtitle }: Props) => {
  return (
    <Card className={`card-stats mb-4 mb-xl-0 border-0 shadow-sm ${style} py-3 shadow-none`}>
      <CardBody>
        <Row className="align-items-center">
          <div className="col">
            <CardTitle
              tag="h5"
              className="text-uppercase text-white mb-1"
              style={{ fontSize: '.8rem', opacity: 0.8 }}
            >
              {title}
            </CardTitle>
            <span className="h2 text-white font-weight-bold mb-0">
              {subtitle}
            </span>
          </div>
          <Col className="col-auto">
            <div className="icon icon-shape bg-white text-info rounded-circle shadow-sm" style={{ width: '45px', height: '45px' }}>
              <i className={icon} style={{ fontSize: '1.1rem', color: '#11cdef' }} />
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

export default AppCardWidget;